"use client";

import dynamic from "next/dynamic";

export const FilterModal = dynamic(() => import("./FilterModal").then((mod) => mod.FilterModal));
